import { getCookieToken } from '@/utils/auth'
import { checkClient, getDictConfig, getQuestionList } from '@/http/api/common'
import { getUserBasicInfo } from '@/http/api/user'
import config from '@/http/config'
import { base64 } from './base64'
import Vue from 'vue'
import { getCookie } from './auth'
import { formatSecondsToTime } from '@/utils/date.js'
import store from '@/store/store.js'
import { getUserVipInfo } from '@/http/api/user'
export const STEAMF_UUID = 'steamf-uuid'

export default {
    checkClientUpdate(that) {
        return new Promise(async (resolve, reject) => {
            let check = Vue.$cookies.get('steamf-box-check')
            if (!check) {
                try {
                    const res = await checkClient()
                    if (res && res.code == 200 && res.data) {
                        that.$Update.show(res.data)
                        reject('弹出版本更新')
                    } else {
                        resolve()
                    }
                } catch (error) {
                    resolve()
                }
            } else {
                resolve()
            }
        })
    },
    isIntNumber: function (value) {
        var reg = /^([1-9]\d*|[0]{1,1})$/
        if (reg.test(value)) {
            return true
        } else {
            return false
        }
    },
    addJS: function (type, url, id) {
        var time = new Date().getTime()
        if ((type = 'js')) {
            var jsNode = document.createElement('script')
            jsNode.src = url + '?t=' + time
            if (id) {
                jsNode.setAttribute('id', id)
            }
            var allScriptNode = document.getElementsByTagName('script')[0]
            allScriptNode.parentNode.appendChild(jsNode, allScriptNode)
        }
    },
    // 提前加载hover状态的图片，解决hover背景闪烁问题
    preloadHoverImg: function (src) {
        var img = new Image()
        img.onload = function () {
            console.log('%c' + src + ' %cis loaded', 'color: green', 'color: #fff')
        }
        img.onerror = function () {
            console.log('error!')
        }
        img.src = src
    },
    getUrlParams: function (urlStr) {
        if (typeof urlStr == 'undefined') {
            // 获取url中"?"符后的字符串
            var url = decodeURIComponent(location.search)
        } else {
            var url = '?' + urlStr.split('?')[1]
            var hashIndex = url.indexOf('#')
            if (hashIndex > -1) {
                url = url.slice(0, hashIndex)
            }
        }

        // 如果没有查询字符串，直接返回空对象
        if (url == '?undefined') {
            return {}
        }

        var theRequest = new Object()
        if (url.indexOf('?') != -1) {
            var str = url.substr(1),
                strs = ''
            strs = str.split('&')
            for (var i = 0; i < strs.length; i++) {
                if (strs[i] && strs[i].split('=')[0]) {
                    theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1] ? decodeURI(strs[i].split('=')[1]) : ''
                }
            }
        }
        return theRequest
    },
    clipboard: function (string) {
        //IE浏览器
        if (window.clipboardData) {
            window.clipboardData.setData('text', string)
            return
        }

        //其它浏览器
        function handler(event) {
            event.clipboardData.setData('text/plain', string)
            event.preventDefault()
            document.removeEventListener('copy', handler, true)
        }

        document.addEventListener('copy', handler, true)
        document.execCommand('copy')
    },
    copy: function (copyContent, txt = '复制成功', time = 1000) {
        // 1. 创建并添加一个输入框元素(最后会销毁)
        var textareaEle = document.createElement('textarea')
        document.body.appendChild(textareaEle)
        // 2. 将需要复制的文本传入输入框, 并调用 select 方法, 选中输入框中文本
        textareaEle.value = copyContent
        textareaEle.select()
        textareaEle.readOnly = 'readOnly'
        textareaEle.style.position = 'absolute'
        textareaEle.style.opacity = 0
        textareaEle.style.left = '-999999px'
        textareaEle.style.top = '-999999px'
        // 3. 调用复制选中文本的方法
        document.execCommand('copy')
        // 4. 销毁输入框
        document.body.removeChild(textareaEle)
        Vue.prototype.$Toast.show(txt, time)
    },
    getScrollBarWidth: function () {
        var outer = document.createElement('div')
        outer.style.overflow = 'scroll'
        outer.style.height = '200px'
        outer.style.width = '100px'
        document.body.appendChild(outer)
        var widthNoScroll = outer.offsetWidth
        var inner = document.createElement('div')
        inner.style.width = '100%'
        outer.appendChild(inner)
        var widthWithScroll = inner.offsetWidth
        scrollBarWidth = widthNoScroll - widthWithScroll
        return scrollBarWidth
    },
    beforeUpload: function (file) {
        if (file instanceof File) {
            var type = file.type === 'image/jpeg' || file.type === 'image/png' || file.type == 'image/gif'
            if (!type) {
                return false
            }
            return true
        }
        return false
    },
    isMobile: function () {
        var userAgentInfo = navigator.userAgent

        var mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']

        var mobile_flag = false

        //根据userAgent判断是否是手机
        for (var v = 0; v < mobileAgents.length; v++) {
            if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
                mobile_flag = true
                break
            }
        }
        return mobile_flag
    },
    buildQueryString: function (sourceInfo) {
        var queryString = ''
        for (var key in sourceInfo) {
            if (sourceInfo.hasOwnProperty(key)) {
                queryString += key + '=' + encodeURIComponent(sourceInfo[key]) + '&'
            }
        }
        queryString = queryString.slice(0, -1)
        return queryString
    },
    // 获取字符串的字符个数
    getCharacterLength: function (str) {
        var tempStr = String(str)
        var count = 0
        for (var v of tempStr) {
            count++
        }
        return count
    },
    // 校验是否为正确的手机号码格式
    checkMobile: function (phone) {
        if (/^1[3-9]\d{9}$/.test(phone)) {
            return true
        } else {
            return false
        }
    },
    debounce: function (func, delay) {
        let timer
        return function () {
            clearTimeout(timer)
            timer = setTimeout(func, delay)
        }
    },
    throttle: function (func, delay) {
        let lastTime = 0
        return function (...args) {
            const currentTime = Date.now()
            if (currentTime - lastTime >= delay) {
                func.apply(this, args)
                lastTime = currentTime
            }
        }
    },
    // 使用UTF-8编码计算字符串占用的字节数
    sizeof: function (str, charset) {
        var total = 0,
            charCode,
            i,
            len
        charset = charset ? charset.toLowerCase() : ''
        if (charset === 'utf-16' || charset === 'utf16') {
            for (i = 0, len = str.length; i < len; i++) {
                charCode = str.charCodeAt(i)
                if (charCode <= 0xffff) {
                    total += 2
                } else {
                    total += 4
                }
            }
        } else {
            for (i = 0, len = str.length; i < len; i++) {
                charCode = str.charCodeAt(i)
                if (charCode <= 0x007f) {
                    total += 1
                } else if (charCode <= 0x07ff) {
                    total += 2
                } else if (charCode <= 0xffff) {
                    total += 3
                } else {
                    total += 4
                }
            }
        }
        return total
    },
    isObject: function (obj) {
        if (Object.prototype.toString.call(obj) == '[object Object]') {
            return true
        }
        return false
    },
    getUserParams: function () {
        var data = {}
        if (getCookieToken()) {
            try {
                var originInfo = getCookieToken().split('.')[1]
                data = JSON.parse(base64().decode(this.padBase64String(originInfo)))
            } catch (error) {}
        }
        return data
    },
    getNowChannel: function () {
        return getCookie('steamf-gamebox-channel') || 'guanwang'
    },
    padBase64String: function (base64Str) {
        while (base64Str && base64Str.length % 4 !== 0) {
            base64Str += '='
        }
        return base64Str
    },
    report: function (arg) {
        var query = this.getUrlParams()
        var channel = query.channel || getCookie('steamf-gamebox-channel') || ''
        var client_ver = getCookie('steamf-gamebox-client_ver') || ''
        var uid = this.getUserParams().uid || ''
        var data = {
            app_id: 207,
            ver: '3.0'
        }
        var params = {}
        params.channel = arg.channel ? arg.channel : channel // 渠道号
        params.client_ver = !client_ver ? '' : client_ver
        params.event_id = arg.event_id !== undefined ? arg.event_id : 26 // event_id 26:每个平台的pvuv

        params.event = arg.event || '盒子行为记录'
        params.n1 = arg.n1 == undefined ? uid : arg.n1 // 用户id
        var tempN2 = 0

        // 特殊处理上导航和右下角数据上报
        if (arg.event_id == 38) {
            if (location.pathname === '/') {
                tempN2 = 0 // 首页不上报游戏id
            } else if (location.pathname === '/vip') {
                tempN2 = 1 // 会员中心上报n2为1
            } else if (location.pathname === '/game') {
                tempN2 = 2 // 游戏库上报n2为2
            } else {
                tempN2 = parseInt(Vue.$cookies.get('box_website_game_id'))
            }
        }

        params.n2 = arg.n2 !== undefined ? parseInt(arg.n2) : tempN2 // 游戏id
        params.n3 = arg.n3 !== undefined ? parseInt(arg.n3) : 0 // 用户行为类型
        params.n4 = arg.n4 !== undefined ? parseInt(arg.n4) : 0 // 行为id
        params.n5 = arg.n5 !== undefined ? parseInt(arg.n5) : 0 // 上报方 1--》前端 2--》服务端 3--》客户端
        params.v1 = arg.v1 !== undefined ? arg.v1 : ''
        params.v2 = arg.v2 !== undefined ? arg.v2 : '' // 商品名称
        params.v3 = arg.v3 !== undefined ? arg.v3 : '' // 类型 show->展示 click->点击购买 buy->创建订单
        params.v4 = arg.v4 !== undefined ? arg.v4 : '' // 订单号
        params.v5 = arg.v5 !== undefined ? arg.v5 : ''
        params.v6 = arg.v6 !== undefined ? arg.v6 : '' // mod下载 1:click,2:view,3:download
        params.f1 = arg.f1 !== undefined ? parseFloat(arg.f1) : 0 // 订单金额
        params.e6 = this.getUUID() || '' // client_id

        data.params = params
        new Image().src = config.LOG_DOMAIN + '?data=' + encodeURIComponent(JSON.stringify(data)) + '&time=' + new Date().getTime()
    },
    getUUID: function () {
        if (getCookie(STEAMF_UUID)) {
            return getCookie(STEAMF_UUID)
        } else {
            const uuid = Vue.prototype.$Uuidv4()
            Vue.$cookies.set(STEAMF_UUID, uuid, 60 * 60 * 24 * 1, '', 'steamf.cn')
            return uuid
        }
    },
    setDialogZindex: function (className, max) {
        try {
            let arr = []
            let arr2 = []
            $.each($('.dialog-mask'), function (index, value) {
                if (!$(value).hasClass('update-content-mask')) {
                    // 排除更新的弹框z-index
                    arr.push($(value).css('z-index'))
                }
            })
            $.each($('.mask-content'), function (index, value) {
                if (!$(value).hasClass('update-content')) {
                    // 排除更新的弹框z-index
                    arr2.push($(value).css('z-index'))
                }
            })

            let maxZindex = Math.max.apply(null, [...arr, ...arr2])
            if (max) {
                maxZindex = max
            }

            $(`.${className} .dialog-mask`).css('z-index', maxZindex + 1)
            $(`.${className} .mask-content`).css('z-index', maxZindex + 2)
        } catch (error) {}
    },
    compareVersion: function (v1, v2) {
        if (v1 == undefined) {
            return -1
        }
        if (v2 == undefined) {
            return 1
        }
        v1 = v1.split('.')
        v2 = v2.split('.')
        const len = Math.max(v1.length, v2.length)

        // 调整两个版本号位数相同
        while (v1.length < len) {
            v1.push('0')
        }
        while (v2.length < len) {
            v2.push('0')
        }

        // 循环判断每位数的大小
        for (let i = 0; i < len; i++) {
            const num1 = parseInt(v1[i])
            const num2 = parseInt(v2[i])

            if (num1 > num2) {
                return 1
            } else if (num1 < num2) {
                return -1
            }
        }

        return 0
    },
    /**
     * 大于 等于 某个 版本
     */
    noLowerThanVersion: function (v1) {
        const client_ver = getCookie('steamf-gamebox-client_ver')
        return this.compareVersion(client_ver, v1) > -1
    },
    // 视频资源地址拼接
    filterVideoUrl(value) {
        let formatValue = String(value)

        if (formatValue) {
            if (formatValue.indexOf('http') > -1) {
                return formatValue
            } else if (formatValue.indexOf('/pic') > -1) {
                return config.PREVIEW_DOMAIN + formatValue
            } else {
                return ''
            }
        }
    },
    // 图片资源地址拼接
    filterImgUrl(value, w_h) {
        let formatValue = String(value)

        if (formatValue) {
            if (formatValue.indexOf('http') > -1) {
                return formatValue
            } else if (formatValue.indexOf('/pic') > -1) {
                // 如果是以webp和gif结尾的图片，直接返回，拼接宽高会有问题
                if (/\.(webp|gif)$/i.test(formatValue)) {
                    return config.PREVIEW_DOMAIN + formatValue
                } else if (w_h) {
                    let arr = formatValue.split('.')
                    return config.PREVIEW_DOMAIN + arr[0] + '_' + w_h + '.' + arr[1]
                } else {
                    return config.PREVIEW_DOMAIN + formatValue
                }
            } else {
                return ''
            }
        }
    },
    formatPhoneNumber(phoneNumber) {
        if (phoneNumber) {
            const stringNumber = String(phoneNumber)
            return stringNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        }
    },
    appendParametersToUrl: function (url, params) {
        if (!url || !this.isObject(params)) {
            return url
        }

        var hashIndex = url.indexOf('#')
        var hash = hashIndex > -1 ? url.slice(hashIndex) : ''
        var urlWithoutHash = hashIndex > -1 ? url.slice(0, hashIndex) : url
        var queryIndex = urlWithoutHash.indexOf('?')
        var path = queryIndex > -1 ? urlWithoutHash.slice(0, queryIndex) : urlWithoutHash
        var query = queryIndex > -1 ? urlWithoutHash.slice(queryIndex + 1) : ''
        var queryList = query ? query.split('&').filter(Boolean) : []
        var paramString = ''

        for (var key in params) {
            if (params.hasOwnProperty(key) && params[key]) {
                if (key == 'userId' && url.indexOf('list.xubei.com') > -1) {
                } else {
                    queryList = queryList.filter((item) => item.split('=')[0] !== key)
                    paramString += '&' + key + '=' + encodeURIComponent(params[key])
                }
            }
        }

        paramString = paramString.slice(1)
        if (paramString) {
            queryList = queryList.concat(paramString.split('&'))
        }

        var queryString = queryList.join('&')

        return path + (queryString ? '?' + queryString : '') + hash
    },
    judgeDevice: function () {
        const userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('android') !== -1) {
            return 'android'
        } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1 || userAgent.indexOf('ipod') !== -1) {
            return 'ios'
        } else if (userAgent.indexOf('harmony') !== -1) {
            // 鸿蒙
            return 'harmony'
        } else {
            return 'other'
        }
    },
    /**
     * 判断是否购买断了这个游戏关联的商品
     * @param {*} g_id
     * @param {*} s_id
     * @returns
     */
    isBuyGoods: function (g_id, s_id) {
        const timeout = 5000 // 超时时间，单位毫秒
        const interval = 50 // 轮询间隔，单位毫秒
        const startTime = Date.now()
        let timeId = null // 改用局部变量存储定时器ID

        return new Promise((resolve) => {
            const checkBuyGooods = () => {
                if (timeId) clearTimeout(timeId) // 清除之前的定时器
                let gid_sid = store.state.vipInfo.gid_sid
                if (!getCookieToken()) {
                    resolve(false)
                    return // 提前返回，避免后续逻辑执行
                } else {
                    if (JSON.stringify(store.state.vipInfo) !== '{}') {
                        if (!gid_sid) {
                            resolve(false)
                            return
                        } else {
                            if (gid_sid[g_id] == s_id) {
                                resolve(true)
                                return
                            } else {
                                resolve(false)
                                return
                            }
                        }
                    } else {
                        if (Date.now() - startTime > timeout) {
                            resolve(false)
                            return
                        } else {
                            timeId = setTimeout(checkBuyGooods, interval) // 存储新的定时器ID
                        }
                    }
                }
            }

            checkBuyGooods()
        })
    },
    /**
     * 判断会员是否过期了
     * @returns 0:会员已过期 1:会员未过期
     */
    judgeVipExpire() {
        const { vipInfo, serverTime } = store.state
        let is_vip = 0,
            expire_time = vipInfo.expire_time,
            hourly_expire_time = vipInfo.hourly_expire_time || 0,
            leftTime = +new Date(expire_time) - serverTime * 1000 // 将服务器时间转换为毫秒

        if (leftTime > 0 || hourly_expire_time > 0) {
            is_vip = 1
        } else {
            is_vip = 0
        }
        return is_vip
    },
    /**
     * 自定义四舍五入函数
     * @param {*} num
     * @returns
     */
    customRound(num) {
        const decimalPart = num - Math.floor(num)
        if (decimalPart >= 0.5) {
            return Math.ceil(num)
        } else {
            return Math.floor(num)
        }
    },
    formatTime(item, value) {
        return item.split(':')[value]
    },
    /**
     * 显示会员文字
     */
    showVipText() {
        const { serverTime, vipInfo } = store.state
        if (serverTime === 0 || JSON.stringify(vipInfo) === '{}') {
            return '00天00时00分'
        } else {
            const vipExpireTime = vipInfo.expire_time
            const leftTime = Math.max(+new Date(vipExpireTime) - serverTime * 1000, 0)
            const hourly_expire_time = vipInfo.hourly_expire_time * 1000 // 转换为毫秒
            if (vipInfo.is_first === 1 && !vipInfo.is_vip) {
                return '您还没有开通会员'
            } else if (leftTime <= 0 && hourly_expire_time <= 0) {
                return '会员已过期'
            } else {
                const time = +new Date(vipInfo.expire_time)
                const targetTime = +new Date('2099/12/31 23:59:59') // 如果包时会员过期时间大于2099年12月31日23:59:59，则视为永久会员
                if (time > targetTime) {
                    return '永久会员'
                } else {
                    const secondTime = Math.ceil((leftTime + hourly_expire_time) / 1000)
                    if (!isNaN(secondTime) && secondTime > 0) {
                        const time = formatSecondsToTime(secondTime)
                        return `${this.formatTime(time, 0)}天${this.formatTime(time, 1)}时${this.formatTime(time, 2)}分`
                    } else {
                        return '00天00时00分'
                    }
                }
            }
        }
    },
    /**
     *
     * @returns 等待实名认证信息
     */
    waitForAuthInfo() {
        const timeout = 5000 // 超时时间，单位毫秒
        const interval = 50 // 轮询间隔，单位毫秒
        const startTime = Date.now()
        let timeId = null // 改用局部变量存储定时器ID

        return new Promise((resolve, reject) => {
            const checkAuthInfo = () => {
                if (timeId) clearTimeout(timeId) // 清除之前的定时器
                const { authInfo, authConfig } = store.state
                if (JSON.stringify(authConfig) !== '{}' && JSON.stringify(authInfo) !== '{}') {
                    resolve()
                } else if (Date.now() - startTime > timeout) {
                    reject(new Error('等待实名认证信息超时'))
                } else {
                    timeId = setTimeout(checkAuthInfo, interval)
                }
            }

            checkAuthInfo()
        })
    },
    /**
     * 循环查询会员信息
     */
    loopQueryVipInfo() {
        if (!getCookieToken()) {
            return false
        }
        clearTimeout(this.loopVipInfoTimeId)
        getUserVipInfo().then(async (res) => {
            if (res.code == 200) {
                const { expire_time: localExpireTime, hourly_expire_time: localHourlyExpireTime } = store.state.vipInfo
                // 本地的包时会员和计时会员的过期时间，如果其中一个和服务端返回的不同，则更新
                // 否则继续循环查询
                const { expire_time, hourly_expire_time } = res.data
                if (localExpireTime != expire_time || localHourlyExpireTime != hourly_expire_time) {
                    store.commit('setUserVipInfo', res.data)
                } else {
                    this.loopVipInfoTimeId = setTimeout(() => {
                        this.loopQueryVipInfo()
                    }, 1000)
                }
            }
        })
    },
    sleep(ms) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, ms)
        })
    },
    // 是否使用新的微信主体登录控制
    useNewWechatSubject() {
        const query = { page: 1, size: 1, type: 'TOGGLE_WECHAT_SUBJECT' }
        if (window.debugUseNewWechatSubject !== undefined) {
            return new Promise((resolve) => {
                resolve(window.debugUseNewWechatSubject)
            })
        }
        return getDictConfig(query)
        .then((res) => {
                if (res.code == 200 && Array.isArray(res.data.list)) {
                    let data = res.data.list[0]
                    let currentServerTime = store.state.serverTime * 1000
                    let targetTime = +new Date(JSON.parse(data.value).start_time)

                    console.log('=======>', `服务器时间：${new Date(currentServerTime)}`, `目标时间：${new Date(targetTime)}`)

                    if (currentServerTime > 0 && targetTime > 0 && currentServerTime > targetTime) {
                        return true
                    }
                    return false
                }

                return false
            })
            .catch(() => {
                return false
            })
    },
    // 判断是否展示协议更新的弹框
    shouldShowAgreementUpdateDialog() {
        // 排查第三方代运营的域名
        if (!getCookieToken() && window.location.pathname.includes('.steamf.cn')) {
            return false
        }

        Promise.all([getQuestionList({ page: 1, size: 10, cate: config.ONE_LEVEL_ID }), getUserBasicInfo()]).then((res) => {
            const everyResIs200 = res.every((item) => item && item.code === 200)
            const list = res[0].data.list.filter((item) => item.cate === config.ONE_LEVEL_ID) || []
            const userInfo = res[1].data || {}
            if (everyResIs200) {
                const time1 = list.find((item) => item.id === config.USER_AGREEMENT_TOW_LEVEL_ID)?.update_time || ''
                const time2 = list.find((item) => item.id === config.PRIVACY_POLICY_TOW_LEVEL_ID)?.update_time || ''

                if (!userInfo.agreement_time || userInfo.agreement_time === '0001-01-01 00:00:00' || (new Date(time1) > new Date(userInfo.agreement_time) && new Date(time2) > new Date(userInfo.agreement_time))) {
                    Vue.prototype.$UpdateRelatedProtocols.show({ showUserAgreement: true, showPrivacyPolicy: true })
                } else if (new Date(time1) > new Date(userInfo.agreement_time)) {
                    Vue.prototype.$UpdateRelatedProtocols.show({ showUserAgreement: true, showPrivacyPolicy: false })
                } else if (new Date(time2) > new Date(userInfo.agreement_time)) {
                    Vue.prototype.$UpdateRelatedProtocols.show({ showUserAgreement: false, showPrivacyPolicy: true })
                }
            }
        })
    }
}
